/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaOperatoreDTO } from '../model/paged-model-tipo-pratica-operatore-dto';
// @ts-ignore
import { PraticheOperatoreCountersDTO } from '../model/pratiche-operatore-counters-dto';
// @ts-ignore
import { PraticheOperatoreCountersFilter } from '../model/pratiche-operatore-counters-filter';
// @ts-ignore
import { PraticheOperatoreStatsDTO } from '../model/pratiche-operatore-stats-dto';
// @ts-ignore
import { TipoPraticaListFilter } from '../model/tipo-pratica-list-filter';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PraticheVistaOperatoreServiceInterface,
    CountPraticheOperatoreRequestParams,
    GetMieTipiPraticaRequestParams,
    StatsPraticheOperatoreRequestParams
} from './pratiche-vista-operatore.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class PraticheVistaOperatoreService extends BaseService implements PraticheVistaOperatoreServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Conteggi delle pratiche aggregati per stato, scoped cross-bando all\&#39;operatore loggato. Scope branchato sull\&#39;authority: SUPERADMIN tutte (comune_id come filtro cross-tenant); ADMIN/OP_COMUNE i bandi dei propri comuniGestiti (nessuna riga user_tipo_pratica richiesta); OP_PRATICA / OP_PRATICA_ESERCENTE solo i bandi assegnati. Filtri opzionali comune_id (dentro lo scope; out-of-scope per i non-SUPERADMIN → 403) e id_tipo_pratica (singolo bando). Tutte le 7 chiavi RichiestaPraticaStatus sempre presenti (zero-fill); le chiavi voucher restano 0 fino a Fase 10bis.
     * @endpoint get /api/v1/gestione/pratiche/counters
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public countPraticheOperatore(requestParameters: CountPraticheOperatoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PraticheOperatoreCountersDTO>;
    public countPraticheOperatore(requestParameters: CountPraticheOperatoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PraticheOperatoreCountersDTO>>;
    public countPraticheOperatore(requestParameters: CountPraticheOperatoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PraticheOperatoreCountersDTO>>;
    public countPraticheOperatore(requestParameters: CountPraticheOperatoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling countPraticheOperatore.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/pratiche/counters`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PraticheOperatoreCountersDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista capability-aware dei TipoPratica visibili all\&#39;operatore loggato. Visibilita\&#39; branchata sull\&#39;authority del caller: OP_COMUNE vede tutti i bandi del proprio comune (capabilities.gestione&#x3D;true); OP_PRATICA / OP_PRATICA_ESERCENTE vedono solo i bandi su cui hanno una riga di assegnazione (capabilities.gestione &#x3D; riga.gestione). Filtri opzionali: tipologia, stato, q, fase, visualizzazione, comune_id, solo_submit_per_cittadino. Default sort: codice ASC. Con solo_submit_per_cittadino&#x3D;true la lista e\&#39; ristretta ai bandi su cui il chiamante puo\&#39; davvero sottomettere per conto del cittadino (capabilities.submit_per_cittadino&#x3D;true): e\&#39; la vista usata dall\&#39;area operatore dell\&#39;app mobile.
     * @endpoint get /api/v1/gestione/pratiche/me/tipi-pratica
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getMieTipiPratica(requestParameters: GetMieTipiPraticaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaOperatoreDTO>;
    public getMieTipiPratica(requestParameters: GetMieTipiPraticaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaOperatoreDTO>>;
    public getMieTipiPratica(requestParameters: GetMieTipiPraticaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaOperatoreDTO>>;
    public getMieTipiPratica(requestParameters: GetMieTipiPraticaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling getMieTipiPratica.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getMieTipiPratica.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/pratiche/me/tipi-pratica`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaOperatoreDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aggregati monetari delle pratiche/voucher, scoped cross-bando all\&#39;operatore loggato (card KPI dashboard). Scope branchato sull\&#39;authority come i counters: SUPERADMIN tutte (comune_id come filtro cross-tenant); ADMIN/OP_COMUNE i bandi dei propri comuniGestiti; OP_PRATICA / OP_PRATICA_ESERCENTE solo i bandi assegnati. Filtri opzionali comune_id (dentro lo scope; out-of-scope per i non-SUPERADMIN → 403) e id_tipo_pratica (singolo bando). Importi BigDecimal scala 2, mai null (COALESCE a 0).
     * @endpoint get /api/v1/gestione/pratiche/stats
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public statsPraticheOperatore(requestParameters: StatsPraticheOperatoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PraticheOperatoreStatsDTO>;
    public statsPraticheOperatore(requestParameters: StatsPraticheOperatoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PraticheOperatoreStatsDTO>>;
    public statsPraticheOperatore(requestParameters: StatsPraticheOperatoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PraticheOperatoreStatsDTO>>;
    public statsPraticheOperatore(requestParameters: StatsPraticheOperatoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling statsPraticheOperatore.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/pratiche/stats`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PraticheOperatoreStatsDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
